type CancelPendingWrite = () => void;

let generation = 0;
let suspended = false;
const pendingWriteCancellers = new Set<CancelPendingWrite>();

export function getPersistenceGeneration(): number {
  return generation;
}

export function isPersistenceWriteAllowed(capturedGeneration: number): boolean {
  return !suspended && capturedGeneration === generation;
}

export function registerPendingPersistenceWrite(
  cancel: CancelPendingWrite
): () => void {
  if (suspended) {
    cancel();
    return () => undefined;
  }

  pendingWriteCancellers.add(cancel);
  return () => pendingWriteCancellers.delete(cancel);
}

/**
 * Stops every mounted persistent reducer before account data is removed.
 * Suspension intentionally lasts until a hard navigation creates a new document.
 */
export function suspendAllPersistence(): void {
  if (suspended) {
    return;
  }

  suspended = true;
  generation += 1;

  for (const cancel of pendingWriteCancellers) {
    cancel();
  }
  pendingWriteCancellers.clear();
}

export function removePersistedReducerData(
  key: string,
  storage: Storage
): void {
  storage.removeItem(key);
  storage.removeItem(`${key}:v2`);
}

/** Test-only escape hatch; production resumes persistence through navigation. */
export function resetPersistenceCoordinatorForTests(): void {
  pendingWriteCancellers.clear();
  generation = 0;
  suspended = false;
}
